import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { withTranslation } from 'react-i18next';
import { filter } from 'lodash';
import Pagination from 'reactstrap/lib/Pagination';
import PaginationItem from 'reactstrap/lib/PaginationItem';
import PaginationLink from 'reactstrap/lib/PaginationLink';

import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import Button from 'reactstrap/lib/Button';
import Input from 'reactstrap/lib/Input';

import Moment from 'react-moment';
import Select  from 'react-select';
import DateTimePicker from 'react-widgets/lib/DateTimePicker';

// import momentLocalizer from 'react-widgets-moment';
import 'react-widgets/dist/css/react-widgets.css';
import * as constants from '../../../constants/constants';
import { PopoverBody, UncontrolledPopover } from 'reactstrap';
import { ENV_MODE } from '../../../constants/constants';
import TransactionPlayerName from './components/TransactionPlayerName';

class AllBans extends React.Component {
  static propTypes = {
    member: PropTypes.shape({
      email: PropTypes.string,
    }),
    allPayments: PropTypes.shape({}),
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
    paymentsCount: PropTypes.number,
    completedPaymentsCount: PropTypes.number,
    initiatedPaymentsCount: PropTypes.number,
    fetchPaymentsRange: PropTypes.func.isRequired,
    fetchCompletedPaymentsRange: PropTypes.func.isRequired,
    fetchInitiatedPaymentsRange: PropTypes.func.isRequired,
    fetchCancelledPaymentsRange: PropTypes.func.isRequired,
    fetchFilteredTransactions: PropTypes.func.isRequired,
    allUsers: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  }

  static defaultProps = {
    member: {},
    allPayments: {},
    paymentsCount: null,
    completedPaymentsCount: null,
    initiatedPaymentsCount: null,
    allUsers: [],
  }

  constructor(props) {
    let date = new Date();

    console.log('date 1', date);

    date = date.setDate(date.getDate() - 3);

    console.log('date 2', date);

    super(props);
    this.state = {
      currentPage: 0,
      pageSize: 50,
      show: 'initiatedPayments',
      isFiltered: true,
      selectedOption: null,
      filterDateFrom: new Date(date),
      filterDateTo: new Date(),
      filterProvider: 'all',
      filterUUID: '',
      selectedEnvOption: ENV_MODE[0],
      filterSource: 'all',
    };

    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    const { fetchPaymentsRange, paymentsCount, fetchFilteredTransactions } = this.props;
    const { selectedEnvOption, filterDateFrom, filterDateTo, show } = this.state;

    const start = paymentsCount - 49;
    const end = paymentsCount;
    const devMode = selectedEnvOption.value === 'dev' ? true : null;

    // fetchPaymentsRange(start, end, devMode);

    fetchFilteredTransactions('all', null, filterDateFrom, filterDateTo, show, '', devMode);
  }


  handleClick(e, index) {
    e.preventDefault();
    const { fetchPaymentsRange, fetchCompletedPaymentsRange, paymentsCount, completedPaymentsCount, fetchInitiatedPaymentsRange, fetchCancelledPaymentsRange, initiatedPaymentsCount } = this.props;
    const { show, isFiltered, selectedEnvOption } = this.state;
    this.setState({
      currentPage: index,
    });

    if (show === 'completed') {
      const start = completedPaymentsCount - (50 * index) - 49;
      const end = completedPaymentsCount - (50 * index);

      fetchCompletedPaymentsRange(start, end);

      this.setState({
        currentPage: index,
      });
    } else if (show === 'initiated') {
      const start = initiatedPaymentsCount - (50 * index) - 49;
      const end = initiatedPaymentsCount - (50 * index);

      fetchInitiatedPaymentsRange(start, end);

      this.setState({
        currentPage: index,
      });
    } else if (show === 'cancelled') {
      const start = initiatedPaymentsCount - (50 * index) - 49;
      const end = initiatedPaymentsCount - (50 * index);

      fetchCancelledPaymentsRange(start, end);

      this.setState({
        currentPage: index,
      });
    } else {
      if (!isFiltered) {
        const start = paymentsCount - (50 * index) - 49;
        const end = paymentsCount - (50 * index);

        console.log('fetchPaymentsRange', start, end);

        fetchPaymentsRange(start, end);

        this.setState({
          currentPage: index,
        });
      } else {
        this.setState({
          currentPage: index,
        });
      }
    }
  }

  changeProvider = (e) => {
    this.setState({ filterProvider: e.target.value});
  }

  changeSource = (e) => {
    this.setState({ filterSource: e.target.value });
  }

  changeShow = (e) => {
    console.log('changeShow');
    console.log(e.target.value);
    this.setState({
      currentPage: 0,
      show: e.target.value,
      isFiltered: true,
    });
  }

  changeFilterDateFrom = (event) => {
    console.log('event', event);
    this.setState({ filterDateFrom: event });
  }

  changeFilterDateTo = (event) => {
    this.setState({ filterDateTo: event });
  }

  changePurchaseOption = (event) => {
    this.setState({
      selectedOption: event,
      isFiltered: true,
    });
  }

  changefilterUUID = (event) => {
    this.setState({ filterUUID : event.target.value });
  }

  filterTransactions = () => {
    const { fetchFilteredTransactions } = this.props;
    const {
      filterDateFrom, filterDateTo, filterProvider, selectedOption, show, filterUUID, selectedEnvOption, filterSource
    } = this.state;
    const devMode = selectedEnvOption.value === 'dev' ? true : null;
    console.log(show, "check client show")

    fetchFilteredTransactions(filterProvider, selectedOption, filterDateFrom, filterDateTo, show, filterUUID, devMode, filterSource);
    this.setState({ isFiltered: true, currentPage: 0 });
  }

  changeEnvOption = (selectedEnvOption) => {
    this.setState({
      selectedEnvOption,
    })
  }

  table() {
    const {
      paymentsCount, allPayments, removedPaymentsCount, allUsers, offset,
    } = this.props;
    const {
      currentPage,
      pageSize,
      isFiltered,
    } = this.state;

    let pagesCount = Math.ceil((paymentsCount) / pageSize);

    if (isFiltered) {
      pagesCount = Math.ceil(allPayments.length / pageSize);
    }

    console.log('allUsersallUsersallUsers', allPayments);


    if (!isFiltered) {
      return (
        <Fragment>
          {allPayments && allPayments.length > 0 && allPayments
            .map((payment, index) => (
              <Fragment key={payment.id}>
                {console.log('payment test', payment)}
                <tr key={payment.id} className={`allUsers-table-row ${index % 2 === 0 ? ('odd') : ('even')}`}>
                  <td className="allUsers-table-col">
                    { payment.id }
                  </td>
                  <td className="allUsers-table-col">
                    <Moment format="DD-MM-YYYY, HH:mm" locale="lv">
                      {payment.date + offset}
                    </Moment>
                  </td>
                  <td className="allUsers-table-col">
                    { payment.userUid }
                  </td>
                  <td className="allUsers-table-col">
                    {
                      payment.userName ? payment.userName : payment?.paymentInfo?.name ? payment?.paymentInfo?.name : (
                        <TransactionPlayerName userId={payment.userUid} />
                      )
                    }
                  </td>
                  <td className="allUsers-table-col">
                    {payment.productNr ? filter(constants.SHOP_PRODUCT_TYPES, ['id', payment.productNr])[0]?.productNr : null}
                  {/*  {payment.productNr === 1 ? 'Purchase - 250Z for 0.85 EUR' : null}
                    {payment.productNr === 2 ? 'Purchase - 500Z for 1.41 EUR' : null}
                    {payment.productNr === 3 ? 'Purchase - 1500Z for 2.85 EUR' : null}
                    {payment.productNr === 4 ? 'Purchase - 4000Z for 4.27 EUR' : null}
                    {payment.productNr === 5 ? 'Purchase - 15000Z for 14.23 EUR' : null}
                    {payment.productNr === 6 ? 'Purchase - Reset balance' : null}
                    {payment.productNr === 7 ? 'Purchase - Reset points' : null}
                    {payment.productNr === 8 ? 'Purchase - Reset profile' : null}
                    {payment.productNr === 9 ? 'Payment for unbanning account' : null} */}
                  </td>
                  <td className="allUsers-table-col">
                    {payment.discountPrice || '-'}
                  </td>
                  <td className="allUsers-table-col">
                    {payment.bonusAmount || '-'}
                  </td>
                  <td className="allUsers-table-col">
                    {payment.status}
                  </td>
                  <td className="allUsers-table-col">
                    { payment.provider }
                  </td>
                  <td className="allUsers-table-col">
                    { payment?.paymentInfo?.source ?? ''}
                  </td>
                  <td className="allUsers-table-col">
                    {(payment.status === 'success' || payment.status === 'completed') ? 'Success' : (payment.status === 'failed') ? 'Failed' : '-'}
                  </td>
                </tr>
              </Fragment>
            ))}
          {paymentsCount > pageSize && (
            <div className="pagination-wrapper">
              <Pagination aria-label="Page navigation example">
                <PaginationItem disabled={currentPage === 0}>
                  <PaginationLink style={{ color: '#000' }} onClick={e => this.handleClick(e, 0)} href="#">
                    {`‹‹‹`}
                  </PaginationLink>
                </PaginationItem>

                <PaginationItem disabled={currentPage <= 0}>
                  <PaginationLink
                    style={{ color: '#000' }}
                    onClick={e => this.handleClick(e, currentPage - 1)}
                    previous
                    href="#"
                  />
                </PaginationItem>

                {[...Array(pagesCount || 1)].map((page, i) => {
                  if (i > currentPage - 3 && i < currentPage + 3) {
                    return (
                      <PaginationItem active={i === currentPage} key={page}>
                        <PaginationLink style={{ color: '#000' }} onClick={e => this.handleClick(e, i)} href="#">
                          {i + 1}
                        </PaginationLink>
                      </PaginationItem>
                    );
                  }

                  return null;
                })}

                <PaginationItem disabled={currentPage >= pagesCount - 1}>
                  <PaginationLink
                    style={{ color: '#000' }}
                    onClick={e => this.handleClick(e, currentPage + 1)}
                    next
                    href="#"
                  />
                </PaginationItem>
                <PaginationItem disabled={currentPage >= pagesCount - 1}>
                  <PaginationLink style={{ color: '#000' }} onClick={e => this.handleClick(e, pagesCount - 1)} href="#">
                    {`›››`}
                  </PaginationLink>
                </PaginationItem>
              </Pagination>
            </div>
          )}
        </Fragment>
      );
    } else {
      return (
        <Fragment>
          {allPayments && allPayments.length > 0 && allPayments.slice(
            currentPage * pageSize,
            (currentPage + 1) * pageSize,
          )
            .map((payment, index) => (
              <Fragment key={payment.id}>
                {console.log('payment test', payment)}
                <tr key={payment.id} className={`allUsers-table-row ${index % 2 === 0 ? ('odd') : ('even')}`}>
                  <td className="allUsers-table-col">
                    { payment.id }
                  </td>
                  <td className="allUsers-table-col">
                    <Moment format="DD-MM-YYYY, HH:mm" locale="lv">
                      {payment.date + offset}
                    </Moment>
                  </td>
                  <td className="allUsers-table-col">
                    { payment.userUid }
                  </td>
                  <td className="allUsers-table-col">
                    {
                      payment.userName ? payment.userName : payment?.paymentInfo?.name ? payment?.paymentInfo?.name : (
                        <TransactionPlayerName userId={payment.userUid} />
                      )
                    }
                  </td>
                  <td className="allUsers-table-col">
                    {
                      filter(constants.SHOP_PRODUCT_TYPES, ['id', payment.productNr])[0]?.productNr
                    }
                  </td>
                  <td className="allUsers-table-col">
                    {payment.discountPrice || '-'}
                  </td>
                  <td className="allUsers-table-col">
                    {payment.bonusAmount || '-'}
                  </td>
                  <td className="allUsers-table-col">
                    { payment.status }
                  </td>
                  <td className="allUsers-table-col">
                    { payment.provider }
                  </td>
                  <td className="allUsers-table-col">
                    { payment?.paymentInfo?.source ?? ''}
                  </td>
                  <td className="allUsers-table-col">
                  {(payment.status === 'success' || payment.status === 'completed') ? 'Success' : (payment.status === 'failed') ? 'Failed' : '-'}
                  </td>
                </tr>
              </Fragment>
            ))}
          {paymentsCount > pageSize && (
            <div className="pagination-wrapper">
              <Pagination aria-label="Page navigation example">
                <PaginationItem disabled={currentPage === 0}>
                  <PaginationLink style={{ color: '#000' }} onClick={e => this.handleClick(e, 0)} href="#">
                    {`‹‹‹`}
                  </PaginationLink>
                </PaginationItem>

                <PaginationItem disabled={currentPage <= 0}>
                  <PaginationLink
                    style={{ color: '#000' }}
                    onClick={e => this.handleClick(e, currentPage - 1)}
                    previous
                    href="#"
                  />
                </PaginationItem>

                {[...Array(pagesCount)].map((page, i) => {
                  if (i > currentPage - 3 && i < currentPage + 3) {
                    return (
                      <PaginationItem active={i === currentPage} key={page}>
                        <PaginationLink style={{ color: '#000' }} onClick={e => this.handleClick(e, i)} href="#">
                          {i + 1}
                        </PaginationLink>
                      </PaginationItem>
                    );
                  }

                  return null;
                })}

                <PaginationItem disabled={currentPage >= pagesCount - 1}>
                  <PaginationLink
                    style={{ color: '#000' }}
                    onClick={e => this.handleClick(e, currentPage + 1)}
                    next
                    href="#"
                  />
                </PaginationItem>

                <PaginationItem disabled={currentPage >= pagesCount - 1}>
                  <PaginationLink style={{ color: '#000' }} onClick={e => this.handleClick(e, pagesCount - 1)} href="#">
                    {`›››`}
                  </PaginationLink>
                </PaginationItem>
              </Pagination>
            </div>
          )}
        </Fragment>
      );
    }
  }

  render() {
    const { t } = this.props;
    const { show, filterProvider, selectedOption, filterDateFrom, filterDateTo, filterUUID, selectedEnvOption, filterSource } = this.state;
    const options = [
      { value: '1', label: 'Purchase - 250Z for 0.85 EUR' },
      { value: '2', label: 'Purchase - 500Z for 1.41 EUR' },
      { value: '3', label: 'Purchase - 1500Z for 2.85 EUR' },
      { value: '4', label: 'Purchase - 4000Z for 4.27 EUR' },
      { value: '5', label: 'Purchase - 15000Z for 14.23 EUR' },
      { value: '6', label: 'Purchase - Reset balance' },
      { value: '7', label: 'Purchase - Reset points' },
      { value: '8', label: 'Purchase - Reset profile' },
      { value: '9', label: 'Payment for unbanning account' },
      { value: '10', label: 'Purchase - Remove ads for 1 month' },
      { value: '11', label: 'Purchase - Remove ads for 1 year' },
      { value: '12', label: 'Purchase - Bronze ticket' },
      { value: '13', label: 'Purchase - Silver ticket' },
      { value: '14', label: 'Purchase - Gold ticket' },
      { value: '15', label: 'Purchase -  VIP for 1 month' },
    ];

    const customStyles = {
      option: (provided, state) => ({
        ...provided,
        borderBottom: '1px dotted pink',
        color: state.isSelected ? 'red' : 'gray',
        padding: 10,
      }),
      singleValue: (provided, state) => {
        const opacity = state.isDisabled ? 0.5 : 1;
        const transition = 'opacity 300ms';
        return { ...provided, opacity, transition };
      }
    }

    return (
      <Fragment>
        <UncontrolledPopover popperClassName={`popover`} placement="right" trigger="focus" target="admin-help-button-all-transactions">
          <PopoverBody className="popover-body">
            A list of all initiated, completed and cancelled transactions in the game.
          </PopoverBody>
        </UncontrolledPopover>
        <div className="admin-page-content">
          <h2>
            Transactions
            <Button className="admin-help-button" id="admin-help-button-all-transactions">
              ?
            </Button>
          </h2>
          <Row>
            <Col sm="1">
              <h5>
                State
              </h5>
              <Input type="select" name="show" className="game-bet-select" value={show} onChange={this.changeShow}>
                <option value="initiatedPayments">All States</option>
                <option value="completedPayments">Completed</option>
                <option value="incompletePayments">Initiated</option>
                <option value="failedPayments">Canceled</option>
              </Input>
            </Col>
            <Col sm="1">
                <div>
                <h5>
                  Provider
              </h5>
                <Input type="select" name="show" className="game-bet-select" value={filterProvider} onChange={this.changeProvider}>
                  <option value="all">All Platforms</option>
                  <option value="every-pay">Every Pay</option>
                  <option value="draugiem">Draugiem</option>
                  <option value="facebook">Facebook</option>
                  <option value="inbox">Inbox</option>
                  <option value="mobile">Mobile</option>
                  {/* <option value="android">Android</option>
                  <option value="apple">IOS</option> */}
                </Input></div>
            </Col>
            <Col sm="5">
                <div>
                  <h5>
                    Purchased Item
                </h5>
                <Select closeMenuOnSelect={false} options={options} isMulti={true} styles={customStyles} value={selectedOption}  onChange={this.changePurchaseOption}/>
                </div>
            </Col>
            <Col sm="2">
                 <div>
                 <h5>
                   From
               </h5>
                    <DateTimePicker
                      format="DD.MM.YYYY"
                      culture="en"
                      time={false}
                      onChange={this.changeFilterDateFrom}
                      value={filterDateFrom}
                      defaultValue={filterDateFrom}
                    />
                </div>
            </Col>
            <Col sm="2">
              <div>
                <h5>
                    To
                </h5>
                <DateTimePicker
                  format="DD.MM.YYYY"
                  culture="en"
                  time={false}
                  onChange={this.changeFilterDateTo}
                  value={filterDateTo}
                  defaultValue={filterDateFrom}
                />
              </div>
            </Col>
            <Fragment>
              <Col sm="4">
                <div>
                  <h5>
                      Player Id
                  </h5>
                    <Input
                      type="string"
                      name="filterValue"
                      id="filterValue"
                      value={filterUUID}
                      onChange={this.changefilterUUID}
                    />
                  </div>
              </Col>
              <Col sm="4">
                <div>
                  <h5>
                    Source
                </h5>
                  <Input type="select" name="source" className="game-bet-select" value={filterSource} onChange={this.changeSource}>
                    <option value="all">All</option>
                    <option value="shop">Shop</option>
                    <option value="balance">Balance</option>
                    <option value="joinRoom">Join Room</option>
                    <option value="joinTournament">Join Tournament</option>
                    <option value="notEnoughWinsModal">Not Enough Wins Modal</option>
                    <option value="bonusPage">Bonus Page</option>
                    <option value="other">Other</option>
                  </Input></div>
              </Col>
              <Col sm="3">
                <div>
                <h5 for="length">
                  Environment
                </h5>
                <Select closeMenuOnSelect={true} options={ENV_MODE} styles={customStyles} value={selectedEnvOption} onChange={this.changeEnvOption} />
              </div>
              </Col>
            </Fragment>
            <Button color="primary" onClick={this.filterTransactions}>
              Filter
            </Button>
          </Row>
          <table style={{ width: '100%', fontSize: 12, textAlign: 'center' }}>
            <colgroup>
              <col span="1" className="" />
            </colgroup>
            <thead>
              <tr>
                <th>
                  Id
                </th>
                <th>
                  Date
                </th>
                <th>
                  Player Id
                </th>
                <th>
                  Player Name
                </th>
                <th>
                  Product No
                </th>
                <th>
                  Discount price
                </th>
                <th>
                  Bonus amount
                </th>
                <th>
                  Status
                </th>
                <th>
                  Provider
                </th>
                <th>
                  Source
                </th>
                <th>
                  Last Screen
                </th>
              </tr>
            </thead>
            <tbody>
              {this.table()}
            </tbody>
          </table>

        </div>
      </Fragment>
    );
  }
}

export default  withTranslation('admin')(AllBans);
